import { useIsStaffAccount } from "@/entities/assistant/assistant.access"
import { useAuthStore } from "@/entities/auth/auth.model"

import { availableWorkspaces, canEnterPmWorkspace } from "./workspace"

/**
 * The signed-in account's workspaces, with the staff answer's loading and failure states.
 *
 * The staff check is a server request, so until it answers the PM workspace is treated as closed:
 * an entry that appears late is better than one shown to someone it is then taken from. Only an
 * admin waits on it -- without the role, PM is closed whatever the server says.
 */
export const useWorkspaceAccess = () => {
  const isAdmin = useAuthStore((state) => state.isAdmin)
  const { isStaff, isPending, isUnavailable } = useIsStaffAccount()
  const audience = { isAdmin, isStaff }

  return {
    workspaces: availableWorkspaces(audience),
    canEnterPm: canEnterPmWorkspace(audience),
    isPending: isAdmin && isPending,
    isUnavailable: isAdmin && isUnavailable,
  }
}
